var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['z-avatar', _vm.classes]},[(_vm.photo)?_c('picture',[_c('z-image',{attrs:{"src":_vm.photo,"alt":_vm.name,"title":_vm.name}})],1):_c('z-icon',{attrs:{"name":"people-default"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }